/**
 * The world and the team a moderated room is in, side by side: the private
 * call's window, the voice monitor's, and the player's and the team's cards
 * over the match list.
 *
 * Each of the four wrote the row out for itself, in three sheets that differed
 * only in their sizes; it is written once here, each size as it was drawn: the
 * narrow call window's small row, the wide monitor's larger one, and the
 * cards', the monitor's sizes in a box of their own.
 */

import { useTranslation } from 'react-i18next';
import styles from './world-and-team.module.css';

const SIZE = {
  narrow: styles.narrow,
  wide: styles.wide,
  boxed: styles.boxed,
} as const;

interface WorldAndTeamProps {
  world: string;
  team: string;
  size: keyof typeof SIZE;
}

export function WorldAndTeam({ world, team, size }: WorldAndTeamProps) {
  const { t } = useTranslation();
  return (
    <div className={`${styles.row} ${SIZE[size]}`}>
      <div className={styles.item}>
        <span className={styles.icon}>🌍</span>
        <div className={styles.text}>
          <span className={styles.label}>{t('matchModeration.world')}</span>
          <span className={styles.value}>{world}</span>
        </div>
      </div>
      <div className={styles.divider}>•</div>
      <div className={styles.item}>
        <span className={styles.icon}>👥</span>
        <div className={styles.text}>
          <span className={styles.label}>{t('matchModeration.team')}</span>
          <span className={styles.value}>{team}</span>
        </div>
      </div>
    </div>
  );
}
